import { SIGNUP_MOTIVATIONS } from '@library/api-motivations'
import { queueTrackingEvent } from '@library/tracking-integration'

export enum TrackingActions {
  CLICK_CONTINUE = 'confirm_motivations',
  CLICK_SKIP = 'skip_motivations',
  SELECT_MOTIVATION = 'select_motivation',
  DESELECT_MOTIVATION = 'deselect_motivation',
}

export type SignupMotivationEvent = typeof SIGNUP_MOTIVATIONS[number]['event']

type CTAClickTrackingData = {
  action: TrackingActions
  properties: {
    motivations?: SignupMotivationEvent[]
    error?: 0
  }
}

function trackAction(action: TrackingActions, properties: CTAClickTrackingData['properties']) {
  queueTrackingEvent<CTAClickTrackingData>({ action, properties })
}

export function trackContinueClick(motivations: SignupMotivationEvent[]) {
  trackAction(TrackingActions.CLICK_CONTINUE, { motivations })
}

export function trackSkipClick() {
  trackAction(TrackingActions.CLICK_SKIP, { error: 0 })
}

export function selectMotivations(motivations: SignupMotivationEvent[]) {
  trackAction(TrackingActions.SELECT_MOTIVATION, { motivations })
}

export function deselectMotivations(motivations: SignupMotivationEvent[]) {
  trackAction(TrackingActions.DESELECT_MOTIVATION, { motivations })
}
